module.exports = "<app-loader *ngIf=\"loaderVisibility\"></app-loader>\r\n<app-modal-dialog *ngIf=\"dialogVisible\" [dialogContent]=\"modalData\" (dialogClosed)=\"hideDialog($event)\" [retryPopup]=\"retryPopup\">\r\n</app-modal-dialog>\r\n<app-main-component [adminClientId]=\"loginService.adminClientId\" *ngIf=\"isUserLoggedIn\"></app-main-component>"


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/engine/engine.component.html
// module id = ../../../../../src/app/core/components/engine/engine.component.html
// module chunks = main